import { render } from "./SubmitMenu.vue?vue&type=template&id=acae07f0&scoped=true"
import script from "./SubmitMenu.vue?vue&type=script&lang=js"
export * from "./SubmitMenu.vue?vue&type=script&lang=js"

import "./SubmitMenu.vue?vue&type=style&index=0&id=acae07f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acae07f0"]])

export default __exports__